// Theme JavaScript

document.addEventListener("DOMContentLoaded", () => {
  // Mobile menu toggle
  const mobileMenuToggle = document.querySelector(".js-mobile-menu-toggle")
  const mobileMenu = document.querySelector(".js-mobile-menu")

  if (mobileMenuToggle && mobileMenu) {
    mobileMenuToggle.addEventListener("click", () => {
      mobileMenu.classList.toggle("is-active")
      mobileMenuToggle.setAttribute(
        "aria-expanded",
        mobileMenuToggle.getAttribute("aria-expanded") === "true" ? "false" : "true",
      )
    })
  }

  // Product image gallery
  const productThumbnails = document.querySelectorAll(".js-product-thumbnail")
  const productMainImage = document.querySelector(".js-product-main-image")

  if (productThumbnails.length && productMainImage) {
    productThumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener("click", function () {
        const newSrc = this.getAttribute("data-full-size-src")
        const newAlt = this.getAttribute("alt")

        productMainImage.setAttribute("src", newSrc)
        productMainImage.setAttribute("alt", newAlt)

        // Remove active class from all thumbnails
        productThumbnails.forEach((thumb) => thumb.classList.remove("is-active"))

        // Add active class to clicked thumbnail
        this.classList.add("is-active")
      })
    })
  }

  // Quantity selector
  const quantitySelectors = document.querySelectorAll(".js-quantity-selector")

  if (quantitySelectors.length) {
    quantitySelectors.forEach((selector) => {
      const decreaseBtn = selector.querySelector(".js-quantity-decrease")
      const increaseBtn = selector.querySelector(".js-quantity-increase")
      const input = selector.querySelector(".js-quantity-input")

      if (decreaseBtn && increaseBtn && input) {
        decreaseBtn.addEventListener("click", () => {
          const currentValue = Number.parseInt(input.value)
          if (currentValue > 1) {
            input.value = currentValue - 1
            // Trigger change event
            input.dispatchEvent(new Event("change", { bubbles: true }))
          }
        })

        increaseBtn.addEventListener("click", () => {
          const currentValue = Number.parseInt(input.value)
          input.value = currentValue + 1
          // Trigger change event
          input.dispatchEvent(new Event("change", { bubbles: true }))
        })
      }
    })
  }

  // Sticky header
  const header = document.querySelector(".header")
  let lastScrollTop = 0

  if (header) {
    window.addEventListener("scroll", () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop

      if (scrollTop > 100) {
        header.classList.add("is-sticky")

        if (scrollTop > lastScrollTop) {
          // Scrolling down
          header.classList.add("is-hidden")
        } else {
          // Scrolling up
          header.classList.remove("is-hidden")
        }
      } else {
        header.classList.remove("is-sticky")
        header.classList.remove("is-hidden")
      }

      lastScrollTop = scrollTop
    })
  }
})

